<template>
  <div id="app">
  
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
   <md-snackbar md-position="top center" ref="snackbar" md-duration="4000">
      <span>{{error}}</span>
      <md-button class="md-accent"  @click="$refs.snackbar.close()">Close</md-button>
  </md-snackbar>		
  </div>
</template>

<script>

  export default {
    name: 'app',
    components: {
      
    },
    data: function() {
      return {
        contacts: [],
        error: "No Errors!",
      }
    },
    
    methods: {
    	performLogout() {
			this.$store.dispatch('logout')
			this.$router.push('/');
		},
		redirectProfile(){
			this.$router.push('/profile');
		},
		
    },
    mounted(){    	
    	this.$store.watch(this.$store.getters.getErrors, error => {
    		
    		  let encode = JSON.parse(error.bodyText);
    		  let error_desc = Object.values(encode).join(", ")
    		
    		  this.error = 'Error! '+ error_desc
    	      this.$refs.snackbar.open();
    	    })
    	this.$store.watch(this.$store.getters.getProfileUpdated, profile_updated => {
    		  this.error = 'Profile was successfully updated!' 
    	      this.$refs.snackbar.open();
    	    })
    },
  }
</script>


<style>
html {
  height: 100%;
}
body {

  height: 100%;
}

.md-theme-default{
    
}

  #app {
  padding: 0;
  height: 100%;
  
  
  
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// App.vue?1948c2d4